import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class ClientIpService {
	constructor(private readonly httpClient: HttpClient) {}

	getClientIp(): Promise<string> {
		return this.httpClient
			.get<{ ip: string }>('https://api.ipify.org?format=json')
			.pipe(
				map((res) => res.ip ?? ''),
				catchError(() => of('')),
			)
			.toPromise()
			.then((ip) => ip ?? '')
	}
}
